<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('menu.promotion_codes')">
        <template v-slot:toolbar>
          <b-button size="sm" v-b-modal.code_pool_add><i class="fa fa-plus mr-2"></i> Kod Havuzu Ekle</b-button>

          <b-modal size="lg" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')" id="code_pool_add" title="Kod Havuzu Ekle">
            <b-row>
              <b-col sm="12">
                <b-form-group label="Havuz Adı">
                  <b-form-input placeholder="Havuz adı giriniz."></b-form-input>
                </b-form-group>
                <b-form-group label="E-Mail Konusu">
                  <b-form-input placeholder="E-mail konusu giriniz."></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-modal>
        </template>
        <template v-slot:preview>

          <b-row>
            <b-col sm="12" lg="3" xl="3" class="mb-2">
              <b-input-group size="sm">
                <b-form-input placeholder="Arama yapın"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary"><i class="fa fa-search"></i> Ara</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>

          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>

          <b-modal size="xl" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')" id="upload_code_list" title="Flormar Oje Hediye">
            <b-row>
              <b-col sm="12">
                <b-alert show variant="warning">
                  <strong>Not :</strong> Yüklenecek dosya *txt formatında olmalıdır ve her satırında bir kod olmalıdır.<br>
                  <strong>Not :</strong> Kodların yanındaki alan seçili ise kullanıldığı anlamına gelmektedir.<br>
                </b-alert>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Kod Ekleme Seçenekleri">
                  <b-form-radio-group
                      v-model="upload_option_selected"
                      :options="upload_options"
                      name="radio-options"
                      stacked
                      @change="changeIt($event,'upload_options')"
                  ></b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="file" label-for="file-default1">
                  <b-form-file id="file-default1" placeholder="Görsel seçiniz" browse-text="Seçim yap"></b-form-file>
                </b-form-group>

                <b-row v-if="same_value">
                  <b-col sm="6">
                    <b-form-group size="sm" label="Değer">
                      <b-form-input size="sm" value=""></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group label="Miktar">
                      <b-form-input size="sm" value="" type="number"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="rand_value">
                  <b-col sm="6">
                    <b-form-group label="Miktar">
                      <b-form-input size="sm" value="" type="number"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-button size="sm" variant="primary" class="mt-8"><i class="fa fa-search"></i> Rastgele Oluştur</b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="8">
                <data-table
                    :items="table.items2"
                    :fields="report.fields2"
                    :paginate="report.paginate"
                    page.sync="3"
                    perPage.sync="10"
                ></data-table>
              </b-col>
            </b-row>
          </b-modal>

          <b-modal size="lg" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')" id="code_pool_edit" title="Flormar Oje Hediye">
            <b-row>
              <b-col sm="12">
                <b-form-group label="Havuz Adı">
                  <b-form-input
                      value="İlvi Ayakkabı %10"
                      placeholder="Havuz adı giriniz."></b-form-input>
                </b-form-group>
                <b-form-group label="E-Mail Konusu">
                  <b-form-input
                      value="İlvi Ayakkabı İndirim Kodu"
                      placeholder="E-mail konusu giriniz."></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-modal>

          <b-modal size="xl" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')" id="template" title="İlvi Ayakkabı %10">
            <b-row>
              <b-col sm="5">
                <prism-editor
                    class="my-editor"
                    v-model="code"
                    :highlight="highlighter"
                    :line-numbers="lineNumbers"
                ></prism-editor>
              </b-col>
              <b-col sm="7">
                <div id="result" v-html="code"></div>
              </b-col>
            </b-row>
          </b-modal>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { PrismEditor } from "vue-prism-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles

export default {
  name: "PromotionCodes",
  components: { DataTable, DashboardBox,PrismEditor },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js,'html'); //returns html
    },
    changeIt(data,input) {
      if (data == 0){
        this.file = true;
        this.same_value = false;
        this.rand_value = false;
      }
      if (data == 1){
        this.file = false;
        this.same_value = true;
        this.rand_value = false;
      }
      if (data == 2){
        this.file = false;
        this.same_value = false;
        this.rand_value = true;
      }
    },
  },
  data() {
    return {
      form : {

      },
      code : "<html>\n" +
          "  <body leftmargin=\"0\" topmargin=\"0\" marginwidth=\"0\" marginheight=\"0\" yahoo=\"fix\" style=\"font-family: Georgia, Times, serif\">\n" +
          "\n" +
          "<!-- Wrapper -->\n" +
          "<table width=\"100%\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\">\n" +
          "    <!-- Start Header-->\n" +
          "    <table width=\"600\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\" class=\"border-complete deviceWidth\" bgcolor=\"#1abc9c\">\n" +
          "        <tr class=\"logotable\">\n" +
          "            <td width=\"100%\">\n" +
          "                <!-- Logo -->\n" +
          "                <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\" class=\"deviceWidth\">\n" +
          "                    <tr style=\"display:inline\">\n" +
          "                        <td id=\"logo\">\n" +
          "                            <a href=\"#\"><img src=\"http://napolyon.limonist.ist/project/images/nap_light.png\" alt=\"\" border=\"0\" /></a>\n" +
          "                        </td>\n" +
          "                    </tr>\n" +
          "                </table>\n" +
          "                <!-- End Logo -->\n" +
          "            </td>\n" +
          "        </tr>\n" +
          "        <tr class=\"social\">\n" +
          "            <td><span class=\"facebook\">f</span></td>\n" +
          "            <td><span class=\"twitter\">t</span></td>\n" +
          "        </tr>\n" +
          "    </table>\n" +
          "\n" +
          "    <!-- End Header -->\n" +
          "    <!-- Banner Text -->\n" +
          "    <table width=\"600\" height=\"108\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\" class=\"border-lr deviceWidth\" bgcolor=\"#fff\">\n" +
          "        <tr>\n" +
          "            <td>\n" +
          "                <p id=\"banner-txt\">Tebrikler!<br/><br/>\n" +
          "                    Napolyon.com'da 2.500 Nap puan'a karşılık gelen İlvi ayakkabı'dan yapacağınız alışverişlerde kullanabileceğiniz %10 indirim değerindeki İlvi ayakkabı indirim kodunuz tanımlanmıştır.<br/><br/>\n" +
          "                    İndirim kodunuz : <strong>{PCODE}</strong>\n" +
          "                </p>\n" +
          "            </td>\n" +
          "        </tr>\n" +
          "    </table>\n" +
          "    <!-- End of Banner Text -->\n" +
          "    <!-- Footer -->\n" +
          "    <table width=\"600\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" align=\"center\" class=\"border-complete deviceWidth\" bgcolor=\"#eeeeed\">\n" +
          "        <tr>\n" +
          "            <td style=\"text-align: center;\">\n" +
          "                <p class=\"footer-txt\"> <b>© Copyright 2021 - Napolyon - Tüm hakları saklıdır.</b>\n" +
          "                    <br/> \n" +
          "                </p>\n" +
          "              <p class=\"footer-txt\">0 (212) 349 49 00 - info@napolyon.com</p>\n" +
          "              <p class=\"footer-txt\">Eski Büyükdere Cad. Özcan Sok. No: 2 34416, 4. Levent / Kağıthane / İstanbul</p>\n" +
          "            </td>\n" +
          "        </tr>\n" +
          "    </table>\n" +
          "    <!-- End of Footer-->\n" +
          "</table>\n" +
          "<!-- End Wrapper -->\n" +
          "</body>\n" +
          "  <style>\n" +
          "  \ttd#logo {\n" +
          "\t  margin: 0 auto;\n" +
          "\t  padding: 14px 10px;\n" +
          "    text-align:left;\n" +
          "\t}\n" +
          ".logotable{\n" +
          "float:left;\n" +
          "}\n" +
          ".social {\n" +
          "  display:inline;\n" +
          "  float:right;\n" +
          "}\n" +
          ".social td {\n" +
          "  display:inline\n" +
          "}\n" +
          ".social .facebook{\n" +
          "    background : #1877f2;\n" +
          "}\n" +
          ".social .twitter{\n" +
          "    background : #1da1f2;\n" +
          "}\n" +
          ".social span{\n" +
          "  width : 25px;\n" +
          "  height: 25px;\n" +
          "  background : #fff;\n" +
          "  padding-lef: 10px;\n" +
          "  margin-left:10px;\n" +
          "  margin-right:10px;\n" +
          "  text-align:center;\n" +
          "  border-radius:50%;\n" +
          "  margin-top:20px;\n" +
          "  float:left;\n" +
          "  font-size:18px;\n" +
          "  color:#fff;\n" +
          "  font-family:system-ui;\n" +
          "  padding-top:2px;\n" +
          "  \n" +
          "}\n" +
          "  td#logo a {\n" +
          "    text-align:left;\n" +
          "  }\n" +
          "\t\n" +
          "\timg {\n" +
          "\t  border: none;\n" +
          "\t  display: block;\n" +
          "\t}\n" +
          "\t\n" +
          "\ta.blue-btn {\n" +
          "\t  display: inline-block;\n" +
          "\t  margin-bottom: 34px;\n" +
          "\t  border: 3px solid #3baaff;\n" +
          "\t  padding: 11px 38px;\n" +
          "\t  font-size: 12px;\n" +
          "\t  font-family: arial;\n" +
          "\t  font-weight: bold;\n" +
          "\t  color: #3baaff;\n" +
          "\t  text-decoration: none;\n" +
          "\t  text-align: center;\n" +
          "\t}\n" +
          "\t\n" +
          "\ta.blue-btn:hover {\n" +
          "\t  background-color: #3baaff;\n" +
          "\t  color: #fff;\n" +
          "\t}\n" +
          "\t\n" +
          "\ta.white-btn {\n" +
          "\t  display: inline-block;\n" +
          "\t  margin-bottom: 30px;\n" +
          "\t  border: 3px solid #fff;\n" +
          "\t  background: transparent;\n" +
          "\t  padding: 11px 38px;\n" +
          "\t  font-size: 12px;\n" +
          "\t  font-family: arial;\n" +
          "\t  font-weight: bold;\n" +
          "\t  color: #fff;\n" +
          "\t  text-decoration: none;\n" +
          "\t  text-align: center;\n" +
          "\t}\n" +
          "\t\n" +
          "\ta.white-btn:hover {\n" +
          "\t  background-color: #fff;\n" +
          "\t  color: #3baaff;\n" +
          "\t}\n" +
          "\t\n" +
          "\t.border-complete {\n" +
          "\t  border-top: 1px solid #dadada;\n" +
          "\t  border-left: 1px solid #dadada;\n" +
          "\t  border-right: 1px solid #dadada;\n" +
          "\t}\n" +
          "\t\n" +
          "\t.border-lr {\n" +
          "\t  border-left: 1px solid #dadada;\n" +
          "\t  border-right: 1px solid #dadada;\n" +
          "\t}\n" +
          "\t\n" +
          "\t#banner-txt {\n" +
          "\t  color: #000;\n" +
          "\t  padding: 15px 32px 0px 32px;\n" +
          "\t  font-family: arial;\n" +
          "\t  font-size: 13px;\n" +
          "\t}\n" +
          "\t\n" +
          "\th2#our-products {\n" +
          "\t  font-family: 'Pacifico';\n" +
          "\t  margin: 23px auto 5px auto;\n" +
          "\t  font-size: 27px;\n" +
          "\t  color: #3baaff;\n" +
          "\t}\n" +
          "\t\n" +
          "\th3.our-products {\n" +
          "\t  font-family: arial;\n" +
          "\t  font-size: 15px;\n" +
          "\t  color: #7c7b7b;\n" +
          "\t}\n" +
          "\t\n" +
          "\tp.our-products {\n" +
          "\t  text-align: center;\n" +
          "\t  font-family: arial;\n" +
          "\t  color: #7c7b7b;\n" +
          "\t  font-size: 12px;\n" +
          "\t  padding: 10px 10px 24px 10px;\n" +
          "\t}\n" +
          "\t\n" +
          "\th2.special {\n" +
          "\t  margin: 0;\n" +
          "\t  color: #fff;\n" +
          "\t  color: #fff;\n" +
          "\t  font-family: 'Pacifico';\n" +
          "\t  padding: 15px 32px 0px 32px;\n" +
          "\t}\n" +
          "\t\n" +
          "\tp.special {\n" +
          "\t  color: #fff;\n" +
          "\t  font-size: 12px;\n" +
          "\t  color: #fff;\n" +
          "\t  text-align: center;\n" +
          "\t  font-family: arial;\n" +
          "\t  padding: 0px 32px 10px 32px;\n" +
          "\t}\n" +
          "\t\n" +
          "\th2#coupons {\n" +
          "\t  color: #3baaff;\n" +
          "\t  text-align: center;\n" +
          "\t  font-family: 'Pacifico';\n" +
          "\t  margin-top: 30px;\n" +
          "\t}\n" +
          "\t\n" +
          "\tp#coupons {\n" +
          "\t  color: #7c7b7b;\n" +
          "\t  text-align: center;\n" +
          "\t  font-size: 12px;\n" +
          "\t  text-align: center;\n" +
          "\t  font-family: arial;\n" +
          "\t  padding: 0 32px;\n" +
          "\t}\n" +
          "\t\n" +
          "\t#socials {\n" +
          "\t  padding-top: 12px;\n" +
          "\t}\n" +
          "\t\n" +
          "\tp.footer-txt {\n" +
          "\t  text-align: center;\n" +
          "\t  color: #303032;\n" +
          "\t  font-family: arial;\n" +
          "\t  font-size: 12px;\n" +
          "\t  padding: 0 32px;\n" +
          "\t}\n" +
          "\t\n" +
          "\t#social-icons {\n" +
          "\t  width: 28%;\n" +
          "\t}\n" +
          "\t\n" +
          "\t@media only screen and (max-width: 640px) {\n" +
          "\t  body[yahoo] .deviceWidth {\n" +
          "\t    width: 440px!important;\n" +
          "\t    padding: 0;\n" +
          "\t  }\n" +
          "\t  body[yahoo] .center {\n" +
          "\t    text-align: center!important;\n" +
          "\t  }\n" +
          "\t  #social-icons {\n" +
          "\t    width: 40%;\n" +
          "\t  }\n" +
          "\t}\n" +
          "\t\n" +
          "\t@media only screen and (max-width: 479px) {\n" +
          "\t  body[yahoo] .deviceWidth {\n" +
          "\t    width: 280px!important;\n" +
          "\t    padding: 0;\n" +
          "\t  }\n" +
          "\t  body[yahoo] .center {\n" +
          "\t    text-align: center!important;\n" +
          "\t  }\n" +
          "\t  #social-icons {\n" +
          "\t    width: 60%;\n" +
          "\t  }\n" +
          "\t}\n" +
          "  </style> \n" +
          "</html>",
      lineNumbers: true,
      file : true,
      same_value : false,
      rand_value : false,
      upload_option_selected : 0,
      upload_options : [
        { text: 'Dosyadan', value: 0 },
        { text: 'Aynı Değerden Üret', value: 1 },
        { text: 'Rastgele Üret', value: 2 },
          ],
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'id', label: '#', sortable: true},
          {key: 'name', label: 'Havuz Adı', sortable: true},
          {key: 'available', label: 'Kullanılabilir', sortable: true},
          {key: 'total', label: 'Toplam', sortable: true},
          {key: 'code_pool_action', label: 'İşlem', sortable: false},
        ],
        fields2: [
          {key: 'checkbox', label: '', sortable: true},
          {key: 'name', label: 'Kod', sortable: true},
          {key: 'created_at', label: 'Oluşturulma Tarihi', sortable: true},
        ],
      },
      table : {
        items : [
          {'id' : '3871304', 'name' : 'Flormar Oje Hediye', 'available' : '340','total' : '1000'},
          {'id' : '3871303', 'name' : 'İlvi ayakkabı %10 indirim', 'available' : '0','total' : '500'},
          {'id' : '3871302', 'name' : 'Bilyoner Bilgi Yarışması', 'available' : '0','total' : '100'},
        ],
        items2 : [
          {'id' : '3871304', 'name' : 'NAPOLYON10', 'created_at' : '12.12.2020'},
          {'id' : '3871303', 'name' : 'NAPOLYON11', 'created_at' : '12.12.2020'},
          {'id' : '3871302', 'name' : 'NAPOLYON12', 'created_at' : '12.12.2020'},
          {'id' : '3871301', 'name' : 'NAPOLYON13', 'created_at' : '12.12.2020'},
          {'id' : '3871309', 'name' : 'NAPOLYON14', 'created_at' : '12.12.2020'},
          {'id' : '3871308', 'name' : 'NAPOLYON15', 'created_at' : '12.12.2020'},
          {'id' : '3871307', 'name' : 'NAPOLYON16', 'created_at' : '12.12.2020'},
          {'id' : '3871306', 'name' : 'NAPOLYON17', 'created_at' : '12.12.2020'},
        ]
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2'), route: "alert" },
      { title: this.$t('menu.promotion_codes') }
    ]);
  }
}
</script>

<style scoped>
.my-editor {
  background: #e7e9f1;
  color: #ccc;
  height: 450px;

  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}
.prism-editor-wrapper .prism-editor__container {
  overflow: scroll;
}

.prism-editor__textarea:focus {
  outline: none;
}
#result{
  padding: 10px;
}
.prism-editor-wrapper .prism-editor__container{
  height: auto !important;
}
</style>
